import './Nearby.css';

function Nearby() {
  const nearbyAttractions = [
    {
      name: "Cumberland Island National Seashore",
      distance: "6 miles",
      description: "A protected island with wild horses, beaches, and hiking trails.",
      image: process.env.PUBLIC_URL + "/images/cumberland.jpg",
      link: "https://www.nps.gov/cuis/index.htm"
    },
    {
      name: "St. Marys Submarine Museum",
      distance: "2 miles",
      description: "A naval museum featuring real submarine artifacts and models.",
      image: process.env.PUBLIC_URL + "/images/submarine-museum.jpg",
      link: "https://www.stmaryssubmuseum.com/"
    },
    {
      name: "Crooked River State Park",
      distance: "7 miles",
      description: "A scenic park known for camping, fishing, hiking, and stunning river views.",
      image: process.env.PUBLIC_URL + "/images/crooked-river.jpg",
      link: "https://gastateparks.org/CrookedRiver"
    }
  ];

  const restaurants = [
    {
      name: "Riverside Café",
      distance: "2.1 miles",
      description: "Local favorite for seafood and Southern-style dishes.",
      image: process.env.PUBLIC_URL + "/images/riverside-cafe.jpg",
      link: "https://www.google.com/search?q=Riverside+Cafe+St+Marys+GA"
    },
    {
      name: "OPS Pizza Kitchen & Café",
      distance: "1.9 miles",
      description: "Family-friendly pizzeria with indoor and outdoor seating.",
      image: process.env.PUBLIC_URL + "/images/ops-pizza.jpg",
      link: "https://www.opspizza.com/locations-stmarys-ga.html"
    }
  ];

  const transport = [
    {
      name: "Jacksonville International Airport (JAX)",
      distance: "35 miles",
      description: "Major airport serving northeast Florida and south Georgia.",
      image: process.env.PUBLIC_URL + "/images/jax-airport.jpg",
      link: "https://flyjacksonville.com/"
    },
    {
      name: "St. Marys Ferry Terminal",
      distance: "2 miles",
      description: "Provides ferry service to Cumberland Island.",
      image: process.env.PUBLIC_URL + "/images/ferry.jpg",
      link: "https://www.cumberlandislandferry.com/"
    }
  ];

  const renderCards = (items) => (
    <div className="card-grid">
      {items.map((item, index) => (
        <a
          href={item.link}
          key={index}
          className="nearby-card"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={item.image} alt={item.name} />
          <div className="nearby-card-content">
            <h4>{item.name}</h4>
            <p>{item.description}</p>
            <span className="distance">{item.distance} away</span>
          </div>
        </a>
      ))}
    </div>
  );

  return (
    <div className="nearby-page">
      <h2>What's Nearby</h2>
      <p className="intro">
        Explore top attractions, great eats, and convenient transportation near Welcome Inn in St. Mary’s, Georgia.
      </p>

      <section>
        <h3>Attractions</h3>
        {renderCards(nearbyAttractions)}
      </section>

      <section>
        <h3>Restaurants</h3>
        {renderCards(restaurants)}
      </section>

      <section>
        <h3>Transportation</h3>
        {renderCards(transport)}
      </section>
    </div>
  );
}

export default Nearby;
